import {Component, Input, OnInit} from '@angular/core';
import {ArticleListInfo} from '../../../core/models/article/article-list-info.model';
import {Pageable} from '../../../core/models/common/pageable.model';
import {ArticleService} from '../../../core/services/article/article.service';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {CommonModule, DatePipe, NgIf} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-articles',
  imports: [
    CommonModule,
    RouterLink,
    TranslateModule,
    DatePipe
  ],
  templateUrl: './articles.component.html',
  styleUrl: './articles.component.scss'
})
export class ArticlesComponent implements OnInit {

  @Input() pageName: string = 'News';
  @Input() articleType: number = 1;
  @Input() currentPage: number = 0;
  @Input() itemsPerPage: number = 9;

  articles: ArticleListInfo[] = [];
  pageInfo: Pageable<ArticleListInfo> | null = null;
  loading: boolean = false;
  error: string | null = null;
  visiblePages: number[] = [];

  constructor(
    private readonly articleService: ArticleService,
    private readonly route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.pageName = data['pageName'] || 'DEFAULT_TITLE';
      this.articleType = data['articleType'] || 1;
      this.itemsPerPage = data['itemsPerPage'] || 9;

      this.loadArticles(this.currentPage, this.itemsPerPage);
    });

  }

  loadArticles(page: number = 0, itemsPerPage: number = 9): void {
    this.loading = true;
    this.error = null;

    this.articleService.getArticles(this.articleType, page, itemsPerPage)
      .subscribe({
        next: (response) => {
          this.pageInfo = response;
          this.articles = response.content;
          this.currentPage = page;
          this.updateVisiblePages();
          this.loading = false;
        },
        error: (err) => {
          console.error('Error loading articles', err);
          this.error = 'Error loading articles. Please try again later.';
          this.loading = false;
        }
      });
  }

  updateVisiblePages(): void {
    const totalPages = this.pageInfo?.page.totalPages || 0;
    const minPage = Math.max(this.currentPage - 2, 0);
    const maxPage = Math.min(this.currentPage + 2, totalPages - 1);
    this.visiblePages = [];

    for (let i = minPage; i <= maxPage; i++) {
      this.visiblePages.push(i);
    }
  }

  changePage(page: number, event: Event): void {
    event.preventDefault();
    if (page < 0 || page >= (this.pageInfo?.page.totalPages || 1)) {
      return;
    }
    this.loadArticles(page, this.itemsPerPage);
  }
}
